<script setup lang="ts">
import { useTranslate } from '@tolgee/vue'
import { useHead } from '@unhead/vue'

import { Flex, Footer, Notification, Dialog, Text, Button } from '@/components'

import { useAppUpdateNotice } from './composables/useAppUpdateNotice'

import '@/styles/theme.css'

const { t } = useTranslate()

const currentYear = new Date().getFullYear()

const FOOTER_LINKS = [
  {
    label: 'eea Website',
    to: 'https://www.european-energy-award.org'
  },
  {
    label: 'Contact',
    to: '/contact'
  },
  {
    label: 'Legal Information',
    to: '/imprint'
  },

  {
    label: 'Privacy Statement',
    to: '/privacy'
  }
]

const FOOTER_COPYRIGHT = [
  `© ${currentYear} Association European Energy Award`,
  'All information is confidential'
]

const { confirm, open, kind, translations } = useAppUpdateNotice()

useHead({
  titleTemplate: '%s - eea Management Tool'
})
</script>

<template>
  <Notification.Provider>
    <Flex
      background-color="tertiary75"
      direction="column"
      min-height="full-dvh"
      :style="{ containerType: 'inline-size' }"
    >
      <router-view />
    </Flex>

    <Footer :links="FOOTER_LINKS" :copyright="FOOTER_COPYRIGHT" />

    <Notification.Root />
  </Notification.Provider>

  <Dialog.Root :open="open" :title="translations.title" size="small">
    <Text as-child line-height="relaxed" :size="40">
      <p>
        {{ translations.message }}
      </p>
    </Text>

    <template v-if="kind === 'update'" #actions>
      <Button variant="primary" :onclick="confirm">
        {{
          t({
            key: 'app.refresh.submit',
            defaultValue: 'Ok'
          })
        }}
      </Button>
    </template>
  </Dialog.Root>
</template>

<style>
@font-face {
  font-display: swap;
  font-family: 'Source Sans Pro';
  font-style: normal;
  src: url('@/assets/SourceSans3VF-Upright.otf.woff2') format('woff2-variations');
}

@font-face {
  font-display: swap;
  font-family: 'Source Sans Pro';
  font-style: italic;
  src: url('@/assets/SourceSans3VF-Italic.otf.woff2') format('woff2-variations');
}

@font-face {
  font-display: swap;
  font-family: 'Outfit';
  src: url('@/assets/Outfit.woff2') format('woff2-variations');
}
</style>
